module.exports = __webpack_public_path__ + "static/media/starter-stering-and-replacement.4a3e1a30.svg";